import { Text } from '@common/components/Typography';
import { media } from 'styled-bootstrap-grid';
import styled, { css } from 'styled-components';

export const BasketItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BasketItemThumbnailColumn = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5px 5px 0 5px;

  ${media.md`
    padding: 10px 10px 0 10px;
  `}
`;

export const BasketItemDetailsColumn = styled.div`
  flex-grow: 1;
`;

export const BasketItemRow = styled.div<{ isDesktop?: boolean; isMobile?: boolean }>`
  display: flex;
  width: 100%;
  padding: 5px 0;

  ${({ isDesktop }) =>
    isDesktop &&
    css`
      display: none;

      ${media.xl`
      display: inline-flex;
      align-items: center;
      width: 100%;
    `}
    `}

  ${({ isMobile }) =>
    isMobile &&
    css`
      display: inline-flex;

      ${media.xl`
      display: none;
    `}
    `}
`;

export const MetaWrapper = styled.div`
  margin-left: 5px;

  ${media.md`
    margin-left: 10px;
  `}
`;

export const BasketItemDetailsRow = styled(BasketItemRow)<{ isVisible: boolean }>`
  flex-direction: column;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.5s ease-in-out;
  justify-content: space-between;

  ${({ isVisible }) =>
    isVisible &&
    css`
      max-height: 750px;
    `}

  ${media.md`
    margin-left 10px;
  `}

  ${media.xl`
    max-height: 750px;
  `}
`;

export const BasketItemColumn = styled.div<{ isGrow?: boolean }>`
  flex-grow: ${({ isGrow }) => (isGrow ? 1 : 0)};
  padding: 0 5px;
  ${media.md`
    padding: 0 10px;
  `}
`;

export const BasketItemDoubleColumn = styled.div<{ isGrow?: boolean }>`
  display: block;
  flex-grow: ${({ isGrow }) => (isGrow ? 1 : 0)};
  padding: 0 5px;
  text-align: right;
  justify-content: right;
  ${media.md`
    padding: 0 10px;
  `}
`;

export const BasketItemPriceWrapper = styled.span`
  margin-right: 10px;
`;

export const BasketItemPricePerNightWrapper = styled.div``;

export const BasketItemMetadataColumn = styled(BasketItemColumn)`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};

  ${media.xl`
    flex-direction: row;
  `}
`;

export const BasketItemTitle = styled(Text)`
  padding: 0;
  font-weight: 600;
  line-height: 23px;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};

  ${media.lg`
    margin-top: 10px;
  `}
`;

export const BasketItemRemoveButton = styled.a`
  line-height: 23px;
`;

export const BasketItemPrice = styled(BasketItemColumn)`
  text-align: right;
`;
export const IconWrapper = styled.a`
  display: flex;
`;

export const PriceWrapper = styled.div`
  display: grid;
`;
